import { noDataRightScreen } from "../../assets/assets";
import "./noDataRightScreen.scss"

const NoDataRightScreen = () => {
    return (
        <div className="nodataright">
            <img src={noDataRightScreen} alt="" />
            <h1>No Data Found</h1>
        </div>
    )
}

export default NoDataRightScreen;